export default __webpack_public_path__ + "static/media/BentonSans.bff1f437.woff";